<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer"
            [routerLink]="bSearch4Car ? ['/carInfo',this.saveModel_Car.get('strUnitID')?.value] : '/' ">

        </i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">

            {{ bSearch4Car ? 'درخواست خدمات و قطعه' : 'درخواست های خدمات و قطعه' }}

        </a>

    </div>

</div>

<div dir="rtl" class="main-result px-2">

    <ng-container *ngIf="!bSearch4Car">

        <div [formGroup]="searchModel" class="row gx-0 gx-md-3 gy-2 gy-md-0 p-2 pt-4">

            <div class="col-md-3 col-12 position-relative">

                <label class="form-label"> موضوع </label>

                <select class="form-select p-2" formControlName="tiServiceParts_Subject">

                    <option value="-1"> انتخاب کنید </option>

                    <option *ngFor="let item of list_Subject" value="{{ item.tiServiceParts_Subject }}">

                        {{ item.strComment }}

                    </option>

                </select>

            </div>

            <div class="col-md-3 col-12 position-relative">

                <label class="form-label"> وضعیت </label>

                <select class="form-select p-2" formControlName="tiServiceParts_Status">

                    <option value="-1"> انتخاب کنید </option>

                    <option *ngFor="let item of list_Status" value="{{ item.tiServiceParts_Status }}">

                        {{ item.strComment }}

                    </option>

                </select>

            </div>

            <div class="col-12 col-md-auto d-flex align-items-center">

                <button class="w-100 btn btn-primary" (click)="getResult()">

                    &nbsp; جستجو &nbsp;

                </button>

            </div>

            <div class="col-12 col-md-auto d-flex align-items-center">

                <button class="w-100 btn btn-warning" (click)="showChart()">

                    &nbsp; نمودار درخواست ها &nbsp;

                </button>

            </div>

            <div class="col-12 col-md-auto d-flex align-items-center">

                <button class="w-100 btn btn-success" (click)="exportexcel('Export_Excel')">

                    خروجی اکسل

                </button>

            </div>

            <div class="col-12 col-md-auto d-flex align-items-center">

                <button class="w-100 btn btn-secondary" printSectionId="print-table" [useExistingCss]="true" ngxPrint
                    printTitle="درخواست های خدمات و قطعه">

                    &nbsp; چاپ &nbsp;

                </button>

            </div>


        </div>

    </ng-container>

    <div class="p-3 mt-2 table-responsive overflow-auto" style="height:86vh;" id="print-table">

        <ng-container *ngIf="!bSearch4Car">

            <input type="text" class="mb-3 form-control d-print-none" placeholder="جستجو کنید..."
                (input)="keyWord_Search($event.target)">

        </ng-container>

        <ng-container *ngIf="bSearch4Car">

            <div class="row gx-2 gy-2 gy-md-0 px-2 w-100 mb-3">

                <div [ngClass]="acssess.bServiceParts_User_Save ? 'col-12 col-md-10' : 'col-12' ">

                    <input type="text" class="form-control" placeholder="جستجو کنید..."
                        (input)="keyWord_Search($event.target)">

                </div>

                <div class="col-12 col-md-2" *ngIf="acssess.bServiceParts_User_Save">

                    <button class="btn btn-success w-100" (click)="open_RequestModal()"> درخواست جدید </button>

                </div>

            </div>

        </ng-container>

        <table class="table border border-2 mt-1 table-responsive table-striped overflow-auto" id="Export_Excel"
            dir="rtl">

            <thead class="">

                <tr class="text-center">

                    <ng-container *ngIf="!bSearch4Car">

                        <th scope="col" class=""> # </th>

                        <th scope="col" class=""> عملیات </th>

                        <th scope="col" class=""> شماره درخواست </th>

                        <th scope="col" class=""> تاریخ </th>

                        <th scope="col" class=""> ساعت </th>

                        <th scope="col" class=""> موضوع </th>

                        <th scope="col" class=""> وضعیت </th>

                        <th scope="col" class=""> پلاک خودرو </th>

                        <th scope="col" class=""> متقاضی </th>

                    </ng-container>

                    <ng-container *ngIf="bSearch4Car">

                        <th scope="col" class=""> # </th>

                        <th scope="col" class=""> عملیات </th>

                        <th scope="col" class=""> شماره درخواست </th>

                        <th scope="col" class=""> تاریخ </th>

                        <th scope="col" class=""> موضوع </th>

                        <th scope="col" class=""> وضعیت </th>

                    </ng-container>

                </tr>

            </thead>

            <tbody>

                <tr class="text-center  dirI " *ngFor="let item of list_Result; let i=index">

                    <ng-container *ngIf="!bSearch4Car">

                        <th class="text-secondary"> {{ i + 1 | faNum }} </th>

                        <td class="text-secondary">

                            <i class="fa fa-eye fa-lg mx-2 pointer" title="مشاهده" (click)="openView_Modal(item)"></i>

                            <i class="fa fa-map-marker fa-lg text-primary mx-2 pointer" title="موقعیت"
                                (click)="showOnMap(item)"></i>

                            <i class="fa fa-trash fa-lg text-danger mx-2 pointer" title="حذف"
                                (click)="remove_Service_Part(item,index)"></i>

                        </td>

                        <td class="text-center"> {{ item.iServiceParts_Request | faNum }} </td>

                        <td class="text-center"> {{ item.strDate | faNum }} </td>

                        <td class="text-center"> {{ item.strTime | faNum }} </td>

                        <td class="text-center"> {{ item.strServiceParts_Subject_strComment | faNum }} </td>

                        <td class="text-center"> {{ item.strServiceParts_Status_strComment | faNum }} </td>

                        <td class="text-center"> {{ item.strVehicleNo | faNum }} </td>

                        <td class="text-center"> {{ item.strFullName | faNum }} </td>

                    </ng-container>

                    <ng-container *ngIf="bSearch4Car">

                        <th class="text-secondary"> {{ i + 1 | faNum }} </th>

                        <td class="text-secondary">

                            <i class="fa fa-eye fa-lg mx-2 pointer" title="مشاهده" (click)="openView_Modal(item)"></i>

                            <i class="fa fa-pencil text-primary fa-lg mx-2 pointer"
                                *ngIf="acssess.bServiceParts_User_Save" (click)="openEdit_Modal(item)"
                                title="ویرایش"></i>

                            <i class="fa fa-trash fa-lg text-danger mx-2 pointer"
                                *ngIf="acssess.bServiceParts_User_Delete" title="حذف"
                                (click)="remove_Service_Part(item,index)"></i>

                        </td>

                        <td class="text-center"> {{ item.iServiceParts_Request | faNum }} </td>

                        <td class="text-center"> {{ item.strDate | faNum }} </td>

                        <td class="text-center"> {{ item.strServiceParts_Subject_strComment | faNum }} </td>

                        <td class="text-center"> {{ item.strServiceParts_Status_strComment | faNum }} </td>

                    </ng-container>

                </tr>

        </table>

    </div>

</div>

<div class="modal fade rtl " id="ViewInfo_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> {{ bNewAction ? 'ثبت اقدام' : ' مشاهده اطلاعات ' }} </h5>

                <button *ngIf="!bNewAction" type="button" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>

                <button *ngIf="bNewAction" type="button" class="btn-close" (click)="bNewAction = false"></button>

            </div>

            <div class="modal-body row gx-2 gy-2 px-3">

                <ng-container *ngIf="!bNewAction">

                    <div class="col-12 col-md-9 row gx-2 gy-2 p-2">

                        <ng-container *ngIf="!bSearch4Car">

                            <p class="col-12 col-md-4"> متقاضی : <span style="color: navy;"> {{ objService.strFullName |
                                    faNum }} </span> </p>

                            <p class="col-12 col-md-4"> نوع خودرو : <span style="color: navy;"> {{
                                    objService.strGPSType_strComment | faNum }} ({{ objService.strMobileGroup_strComment
                                    }}) </span> </p>

                            <p class="col-12 col-md-4"> پلاک خودرو : <span style="color: navy;"> {{
                                    objService.strVehicleNo | faNum }} </span> </p>

                            <p class="col-12 col-md-4"> تاریخ : <span style="color: navy;"> {{ objService.strDate |
                                    faNum }} </span> </p>

                            <p class="col-12 col-md-4"> ساعت : <span style="color: navy;"> {{ objService.strTime | faNum
                                    }} </span> </p>

                            <p class="col-12 col-md-4"> موضوع : <span style="color: navy;"> {{
                                    objService.strServiceParts_Subject_strComment | faNum }} </span> </p>

                            <p class="col-12 col-md-4"> مقدار : <span style="color: navy;"> {{ objService.strValue |
                                    faNum }} </span> </p>

                            <p class="col-12 col-md-4"> وضعیت : <span style="color: navy;"> {{
                                    objService.strServiceParts_Status_strComment | faNum }} </span> </p>

                            <p> توضیحات : <span style="color: navy;"> {{ objService.strComment | faNum }} </span> </p>

                        </ng-container>

                        <ng-container *ngIf="bSearch4Car">

                            <p class="col-12 col-md-4"> تاریخ ثبت : <span style="color: navy;"> {{ objService.strDate |
                                    faNum }} </span> </p>

                            <p class="col-12 col-md-4"> زمان ثبت : <span style="color: navy;"> {{ objService.strTime |
                                    faNum }} </span> </p>

                            <p class="col-12 col-md-4"> وضعیت : <span style="color: navy;"> {{
                                    objService.strServiceParts_Status_strComment | faNum }} </span> </p>

                            <p class="col-12 col-md-4"> موضوع : <span style="color: navy;"> {{
                                    objService.strServiceParts_Subject_strComment | faNum }} </span> </p>

                            <p class="col-12 col-md-4"> مقدار : <span style="color: navy;"> {{ objService.strValue |
                                    faNum }} </span> </p>

                            <p> توضیحات : <span style="color: navy;"> {{ objService.strComment | faNum }} </span> </p>

                            <p> تعداد اقدامات ثبت شده : <span style="color: navy;"> {{ list_Proceeding.length | faNum }}
                                    مورد </span> </p>

                        </ng-container>

                    </div>

                    <div class="col-12 col-md-3">

                        <img class="request-img w-100 h-100" [ngClass]="objService.strImage != '' ? 'zoom-cursor' : '' "
                            (click)="objService.strImage != '' ? fullScreen_Image() : '' " id="fullScreen_" src="{{ objService.strImage != '' ?
                            
                            'data:image/jpeg;base64,' + objService.strImage :
    
                            '../../../assets/Img/no-image.png' }}">

                    </div>

                    <section class="col-12 row gx-2 gy-2 gy-md-0 mt-4">

                        <ng-container *ngIf="!bSearch4Car">

                            <div class="col-12 col-md-10">

                                <input type="text" class="w-100 mb-2 form-control" placeholder="جستجو کنید..."
                                    (input)="keyWord_Search_Proceeding($event.target)">

                            </div>

                            <div class="col-12 col-md-2">

                                <button class="w-100 btn btn-success" [disabled]="(objService.tiServiceParts_Status == 99 ||
                                    
                                    objService.tiServiceParts_Status == 98 )" [title]="(objService.tiServiceParts_Status == 99 || objService.tiServiceParts_Status == 98 ) 
                                    
                                    ? 'شما نمی توانید برای این درخواست اقدامی ثبت کنید' : '' "
                                    (click)="bNewAction=true">

                                    اقدام جدید

                                </button>

                            </div>

                        </ng-container>

                        <table class="table border border-2 table-responsive table-striped overflow-auto">

                            <thead class=" ">

                                <tr class="text-center">

                                    <th scope="col" class=""> # </th>

                                    <th scope="col" class=""> تاریخ </th>

                                    <th scope="col" class=""> ساعت </th>

                                    <th scope="col" class=""> کاربر </th>

                                    <th scope="col" class=""> وضعیت </th>

                                    <th scope="col" class=""> توضیحات </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="text-center  dirI " *ngFor="let item of list_Proceeding; let i=index">

                                    <th class="text-secondary"> {{ i + 1 | faNum }} </th>

                                    <td class="text-center"> {{ item.strDate | faNum }} </td>

                                    <td class="text-center"> {{ item.strTime | faNum }} </td>

                                    <td class="text-center"> {{ item.strFullName | faNum }} </td>

                                    <td class="text-center"> {{ item.strServiceParts_Status_strComment | faNum }} </td>

                                    <td class="text-center"> {{ item.strComment | faNum }} </td>

                                </tr>

                        </table>

                    </section>

                </ng-container>

                <ng-container *ngIf="bNewAction">

                    <div [formGroup]="saveModel" class="col-md-4 col-12 position-relative">

                        <select class="form-select p-2" formControlName="tiServiceParts_Status">

                            <option value="-1"> * وضعیت </option>

                            <option *ngFor="let item of list_Status" value="{{ item.tiServiceParts_Status }}">

                                {{ item.strComment }}

                            </option>

                        </select>

                    </div>

                    <div [formGroup]="saveModel" class="col-12 mt-3">

                        <textarea class="form-control" style="height:150px; max-height:150px ; resize: none;"
                            formControlName="strComment" placeholder="* توضیحات خود را وارد کنید">

                        </textarea>

                    </div>

                    <div class="col-12 d-flex justify-content-end">

                        <div class="col-12 col-md-2">

                            <button class="w-100 btn btn-success" (click)="submitAction()"> ذخیره </button>

                        </div>

                    </div>

                </ng-container>

            </div>

            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="newRequest_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> {{ editMode ? 'ویرایش' : 'ثبت درخواست' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div [formGroup]="saveModel_Car" class="modal-body row gx-2 gy-3 px-3">

                <div class="col-md-6 col-12 position-relative">

                    <label class="form-label"> موضوع </label>

                    <select class="form-select p-2" formControlName="tiServiceParts_Subject">

                        <option value="-1"> انتخاب کنید </option>

                        <option *ngFor="let item of list_Subject" value="{{ item.tiServiceParts_Subject }}">

                            {{ item.strComment }}

                        </option>

                    </select>

                </div>

                <div class="col-md-6 col-12 position-relative">

                    <label class="form-label"> مقدار </label>

                    <input type="text" class="w-100 h-100 form-control" formControlName="strValue">

                </div>

                <div class="col-12 position-relative">

                    <textarea class="form-control" style="height:150px; max-height:150px ; resize: none;"
                        formControlName="strComment" placeholder=" توضیحات ">

                    </textarea>

                </div>

                <div class="col-12">

                    <div class="w-50 mx-auto p-2">

                        <button class="w-100 btn btn-primary" (click)="fileInput.click()"> افزودن تصویر </button>

                        <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0])" />


                    </div>

                </div>

                <ng-container *ngIf="saveModel_Car.value.strImage != '' ">

                    <div class="col-md-6 col-12 mx-auto mt-2">

                        <img class="border border-2 rounded p-2 pointer" width="100%"
                            style="max-height: 360px; object-fit: cover;"
                            src="data:image/jpeg;base64,{{saveModel_Car.value.strImage}}" (click)="fileInput.click()"
                            alt="">

                    </div>

                </ng-container>

                <div class="col-12 d-flex ">

                    <div class="col-12 col-md-2">

                        <button class="w-100 btn" [ngClass]="editMode ? 'btn-primary' : 'btn-success' "
                            (click)="editMode ? editService() : saveService() ">

                            {{ editMode ? 'ویرایش' : 'ذخیره' }}

                        </button>

                    </div>

                </div>

            </div>

            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="Chart_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> نمودار درخواست ها </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="row gx-2 gy-0">

                    <div class="col-12 chart1 rounded shadow mb-3">

                        <div class="">

                            <p class="text-center f18"> تعداد درخواست به تفکیک وضعیت </p>

                            <canvas id="myChart1" style="max-height: 250px !important;"></canvas>

                        </div>

                    </div>

                    <div class="col-12 chart2 rounded shadow mb-3">

                        <div class="">

                            <p class="text-center f18"> تعداد درخواست به تفکیک موضوع </p>

                            <canvas id="myChart2" style="max-height: 250px !important;"></canvas>

                        </div>

                    </div>

                </div>

            </div>

            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>